module.exports = __webpack_public_path__ + "static/media/p13_img2.c613f452.png";